import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.symbol.description.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { getLocalISODateString, parseAndConvertDates } from "@dp/common";
import moment from "moment-timezone";

var Check = /*#__PURE__*/function () {
  function Check(config, axios) {
    _classCallCheck(this, Check);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Check, [{
    key: "getMobilePaySessionInfo",
    value: function () {
      var _getMobilePaySessionInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(isCallinVal) {
        var commonQueryParams, conceptCode, locale, isCallin, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                conceptCode = this.config.getConceptCode();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                isCallin = isCallinVal ? "true" : "false";
                _context.next = 6;
                return this.axios.get(this.config.postfix.MOBILE_PAY_SESSION_INIT, {
                  params: {
                    locale: locale,
                    conceptCode: conceptCode,
                    isCallin: isCallin
                  }
                });

              case 6:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMobilePaySessionInfo(_x) {
        return _getMobilePaySessionInfo.apply(this, arguments);
      }

      return getMobilePaySessionInfo;
    }()
  }, {
    key: "getCheckDetails",
    value: function () {
      var _getCheckDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(paymentCode) {
        var commonQueryParams, conceptCode, locale, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                conceptCode = this.config.getConceptCode();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context2.next = 5;
                return this.axios.get(this.config.postfix.MOBILE_PAY_CHECK_API, {
                  params: {
                    locale: locale,
                    conceptCode: conceptCode,
                    paymentCode: paymentCode
                  }
                });

              case 5:
                response = _context2.sent;
                return _context2.abrupt("return", this._adjustTippableAmountForMobilePay(parseAndConvertDates(response.data)));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCheckDetails(_x2) {
        return _getCheckDetails.apply(this, arguments);
      }

      return getCheckDetails;
    }() // Temporary fix to add tax to tippableAmount for web.
    // This will be removed once the backend starts giving tippable amount
    // as (subTotal + tax). Currently tippableAmount is equal to subTotal
    // for the web api.

  }, {
    key: "_adjustTippableAmountForMobilePay",
    value: function _adjustTippableAmountForMobilePay(data) {
      var _data$successResponse, _order$tippableAmount, _order$taxAmount;

      var order = data === null || data === void 0 ? void 0 : (_data$successResponse = data.successResponse) === null || _data$successResponse === void 0 ? void 0 : _data$successResponse.order;
      order.tippableAmount.value = (order === null || order === void 0 ? void 0 : (_order$tippableAmount = order.tippableAmount) === null || _order$tippableAmount === void 0 ? void 0 : _order$tippableAmount.value) + (order === null || order === void 0 ? void 0 : (_order$taxAmount = order.taxAmount) === null || _order$taxAmount === void 0 ? void 0 : _order$taxAmount.value);
      return data;
    }
  }, {
    key: "getCheckSummary",
    value: function () {
      var _getCheckSummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(tkn) {
        var _response$data;

        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.axios.get(this.config.postfix.CURBSIDE_CHECK_SUMMARY_API, {
                  params: {
                    tkn: tkn
                  }
                });

              case 2:
                response = _context3.sent;

                if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.orderSummary) === "true")) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return");

              case 7:
                throw response;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCheckSummary(_x3) {
        return _getCheckSummary.apply(this, arguments);
      }

      return getCheckSummary;
    }()
  }, {
    key: "applyCoupon",
    value: function () {
      var _applyCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dashCheckId, couponCode) {
        var commonQueryParams, conceptCode, locale, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                conceptCode = this.config.getConceptCode();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context4.next = 5;
                return this.axios.post([this.config.postfix.MOBILE_PAY_APPLY_COUPON_API, dashCheckId].join("/"), {
                  couponCode: couponCode
                }, {
                  params: {
                    locale: locale,
                    conceptCode: conceptCode
                  }
                });

              case 5:
                response = _context4.sent;
                return _context4.abrupt("return", this._adjustTippableAmountForMobilePay(parseAndConvertDates(response.data)));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function applyCoupon(_x4, _x5) {
        return _applyCoupon.apply(this, arguments);
      }

      return applyCoupon;
    }()
  }, {
    key: "removeCoupon",
    value: function () {
      var _removeCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dashCheckId, couponCode) {
        var commonQueryParams, conceptCode, locale, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                conceptCode = this.config.getConceptCode();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context5.next = 5;
                return this.axios.post([this.config.postfix.MOBILE_PAY_REMOVE_COUPON_API, dashCheckId].join("/"), {
                  couponCode: couponCode
                }, {
                  params: {
                    locale: locale,
                    conceptCode: conceptCode
                  }
                });

              case 5:
                response = _context5.sent;
                return _context5.abrupt("return", this._adjustTippableAmountForMobilePay(parseAndConvertDates(response.data)));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function removeCoupon(_x6, _x7) {
        return _removeCoupon.apply(this, arguments);
      }

      return removeCoupon;
    }()
  }, {
    key: "sendEmailConfirmation",
    value: function () {
      var _sendEmailConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dashCheckId, emailId, checkNumber) {
        var _response$data2;

        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.axios.post([this.config.postfix.MOBILE_PAY_SEND_EMAIL_CONFIRMATION, dashCheckId].join(""), {
                  emailId: emailId,
                  checkNumber: checkNumber,
                  type: "email"
                });

              case 2:
                response = _context6.sent;

                if (!((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.successResponse) === "true")) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return");

              case 7:
                throw response;

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function sendEmailConfirmation(_x8, _x9, _x10) {
        return _sendEmailConfirmation.apply(this, arguments);
      }

      return sendEmailConfirmation;
    }()
  }, {
    key: "payCheck",
    value: function () {
      var _payCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dashCheckId, payCheckRequest) {
        var commonQueryParams, conceptCode, locale, payments, emailId, firstName, lastName, dfpParams, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                conceptCode = this.config.getConceptCode();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                payments = payCheckRequest.payments;
                emailId = payCheckRequest === null || payCheckRequest === void 0 ? void 0 : payCheckRequest.emailId;
                firstName = payCheckRequest === null || payCheckRequest === void 0 ? void 0 : payCheckRequest.firstName;
                lastName = payCheckRequest === null || payCheckRequest === void 0 ? void 0 : payCheckRequest.lastName;
                dfpParams = payCheckRequest.bamsCorrelationId ? {
                  correlationId: payCheckRequest.bamsCorrelationId,
                  customerLocalDate: getLocalISODateString(moment().toDate())
                } : {};
                delete payCheckRequest.bamsCorrelationId;
                _context7.next = 11;
                return this.axios.post([this.config.postfix.MOBILE_PAY_PAYMENT_API, dashCheckId].join(""), {
                  emailId: emailId,
                  firstName: firstName,
                  lastName: lastName,
                  paymentCollection: {
                    "atg-rest-class-type": "java.util.ArrayList",
                    "atg-rest-class-descriptor": {
                      "atg-rest-values": {
                        "container-class": "java.util.ArrayList",
                        "element-class": "com.darden.integration.paymentservice.bean.TransactionalDetail"
                      }
                    },
                    "atg-rest-values": payments.map(function (payment) {
                      if (payment.creditCard) {
                        var _payment$creditCard$b, _payment$creditCard$b2, _payment$creditCard$b3, _payment$creditCard$b4;

                        var defaultCard = payment.creditCard["default"];
                        delete payment.creditCard["default"];
                        var isVaulted = payment.creditCard.isVaulted;
                        delete payment.creditCard.isVaulted;
                        var saveCardToProfile = payment.creditCard.saveCardToProfile;
                        var saveCardParams = saveCardToProfile || isVaulted ? {
                          updateSavedCardMandate: payment.creditCard.updateSavedCardMandate,
                          acceptClientType: payment.creditCard.acceptClientType,
                          acceptConceptCode: conceptCode,
                          saveCardToProfile: true
                        } : {};
                        delete payment.creditCard.saveCardToProfile;
                        var vaultedCardParams = isVaulted ? {
                          vaultedCard: "true"
                        } : {
                          makePayment: true
                        };
                        var cardOnFileFlag = saveCardToProfile || isVaulted ? {
                          cardOnFile: true
                        } : {
                          cardOnFile: false
                        };
                        return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, payment), vaultedCardParams), cardOnFileFlag), {}, {
                          validateBillingAddress: (_payment$creditCard$b = payment.creditCard.billingAddress) !== null && _payment$creditCard$b !== void 0 && _payment$creditCard$b.address1 && (_payment$creditCard$b2 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b2 !== void 0 && _payment$creditCard$b2.postalCode && (_payment$creditCard$b3 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b3 !== void 0 && _payment$creditCard$b3.firstName && (_payment$creditCard$b4 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b4 !== void 0 && _payment$creditCard$b4.lastName ? true : false,
                          "default": defaultCard,
                          creditCard: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.CreditCardBean"
                          }, payment.creditCard), {}, {
                            billingAddress: _objectSpread({
                              "atg-rest-class-type": "atg.core.util.Address"
                            }, payment.creditCard.billingAddress)
                          }, payment.creditCard.paymentCVV ? {
                            paymentCVVEnabled: true
                          } : {}), dfpParams), saveCardParams)
                        });
                      }

                      if (payment.giftCard) {
                        var gcNumber = payment.giftCard.giftCardNumber;

                        if (gcNumber) {
                          payment.giftCard.giftCardNumber = gcNumber.split("-").join("");
                        }

                        return _objectSpread(_objectSpread({}, payment), {}, {
                          giftCard: _objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.GiftCardPaymentBean"
                          }, payment.giftCard)
                        }, dfpParams);
                      }

                      if (payment.payPalPayment) {
                        return _objectSpread(_objectSpread({}, payment), {}, {
                          payPalPayment: _objectSpread(_objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.PayPalPaymentBean"
                          }, payment.payPalPayment), {}, {
                            type: "PAYPAL_MPAY"
                          })
                        }, dfpParams);
                      }

                      if (payment.paypalPayment) {
                        var paypalPayment = payment.paypalPayment;
                        delete payment.paypalPayment;
                        return _objectSpread(_objectSpread({}, payment), {}, {
                          transType: "PPP",
                          dardenDigitalWalletBean: _objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.DardenDigitalWalletBean"
                          }, paypalPayment),
                          authTransID: "",
                          status: "SUCCESS",
                          validateBillingAddress: false
                        }, dfpParams);
                      }

                      if (payment.googlePayPayment) {
                        var googlePayPayment = payment.googlePayPayment;
                        delete payment.googlePayPayment;
                        delete googlePayPayment.transcationInfo.info;

                        if (googlePayPayment.transcationInfo.description) {
                          googlePayPayment.transcationInfo.description = encodeURIComponent(googlePayPayment.transcationInfo.description);
                        }

                        return _objectSpread(_objectSpread({}, payment), {}, {
                          transType: "GP",
                          dardenDigitalWalletBean: _objectSpread(_objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.DardenDigitalWalletBean"
                          }, googlePayPayment), {}, {
                            sdkVersion: "ECv1"
                          }),
                          authTransID: "",
                          status: "SUCCESS",
                          validateBillingAddress: false
                        }, dfpParams);
                      }

                      if (payment.applePayPayment) {
                        var applePayPayment = payment.applePayPayment;
                        delete payment.applePayPayment;

                        if (applePayPayment.transcationInfo.paymentMethod.displayName) {
                          applePayPayment.transcationInfo.paymentMethod.displayName = encodeURIComponent(applePayPayment.transcationInfo.paymentMethod.displayName);
                        }

                        return _objectSpread(_objectSpread({}, payment), {}, {
                          transType: "APP",
                          dardenDigitalWalletBean: _objectSpread(_objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.DardenDigitalWalletBean"
                          }, applePayPayment), {}, {
                            sdkVersion: "EC_v1"
                          }),
                          authTransID: "",
                          status: "SUCCESS",
                          validateBillingAddress: false
                        }, dfpParams);
                      }

                      return null;
                    })
                  }
                }, {
                  params: {
                    locale: locale,
                    conceptCode: conceptCode
                  }
                });

              case 11:
                response = _context7.sent;
                return _context7.abrupt("return", parseAndConvertDates(response.data));

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function payCheck(_x11, _x12) {
        return _payCheck.apply(this, arguments);
      }

      return payCheck;
    }()
  }]);

  return Check;
}();

export { Check as default };